import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { ReportTableType } from '../../model/reportTableType';
import { useMediaQuery } from 'react-responsive';

interface IProps {
  inputLabel?: string;
  optionsData?: string[];
  selectedOptions: Function;
  tableName: ReportTableType;
  areaCode: string[];

}

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 224,
      width: 150,
    },
  },
};

const MenuPropsMobile = {
  PaperProps: {
    style: {
      maxHeight: 200,
      maxWidth: 130,
      fontSize: 12,
      fontWeight: 10,
    },
  },
};

let allSelected = false;

function getStyles(option: string, options: string[], theme: Theme) {
  return {
    fontWeight: options.indexOf(option) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
}

export default function MultiSelectDropDown({ inputLabel, optionsData, selectedOptions, tableName, areaCode }: IProps) {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' });

  const theme = useTheme();

  const [optionValues, setOptionValues] = React.useState<string[]>([]);

  const [selectAll, setSelectAll] = React.useState('SELECT ALL');

  const allSelection = () => {
    if (selectAll === 'SELECT ALL') {
      setOptionValues(areaCode);
      selectedOptions(areaCode);
      setSelectAll('CLEAR ALL');
    } else {
      setOptionValues([]);
      selectedOptions([]);
      setSelectAll('SELECT ALL');
    }
    allSelected = true;
  };

  const handleChange = (event: SelectChangeEvent<typeof optionValues>) => {
    const {
      target: { value },
    } = event;
    let values: string[];
    values = typeof value === 'string' ? value.split(',') : value;
    if(!allSelected) {
      setOptionValues(values);
      selectedOptions(values);
    }

    if (values.length === 0) {
      setSelectAll('SELECT ALL');
    } else if (values.length === areaCode.length) {
      setSelectAll('CLEAR ALL');
    }
    allSelected = false;

  };

  return (
    <>
      {!isTabletOrMobile && (
        <FormControl sx={{ m: 1, width: 165 }}>
          <InputLabel id="area_input">{inputLabel}</InputLabel>
          <Select
            labelId="area_label"
            id="area_label_id"
            data-testid="pictureDay-emCompletion-dropdown"
            multiple={tableName !== ReportTableType.PICTURE_DAY && tableName !== ReportTableType.EM_COMPLETION_STATUS}
            value={optionValues}
            onChange={handleChange}
            input={<OutlinedInput label={inputLabel} />}
            MenuProps={MenuProps}
          >
            {tableName !== ReportTableType.PICTURE_DAY && tableName !== ReportTableType.EM_COMPLETION_STATUS && <MenuItem onClick={allSelection}>{selectAll}</MenuItem>}
            {optionsData?.map((option) => (
              <MenuItem key={option} value={option} style={getStyles(option, optionValues, theme)}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {isTabletOrMobile && (
        <FormControl size="small" sx={{ m: 1, minWidth: 130, maxWidth: 130 }}>
          <InputLabel
            sx={{
              fontSize: '12px',
              fontWeight: 10,
            }}
            id="area_input"
          >
            {inputLabel}
          </InputLabel>
          <Select
            labelId="area_label"
            id="area_label_id"
            multiple={tableName !== ReportTableType.PICTURE_DAY && tableName !== ReportTableType.EM_COMPLETION_STATUS}
            value={optionValues}
            onChange={handleChange}
            input={<OutlinedInput label={inputLabel} />}
            MenuProps={MenuPropsMobile}
          >
            {tableName !== ReportTableType.PICTURE_DAY && tableName !== ReportTableType.EM_COMPLETION_STATUS  && (
              <MenuItem
                sx={{
                  fontSize: '12px',
                  fontWeight: 10,
                }}
                onClick={allSelection}
              >
                {selectAll}
              </MenuItem>
            )}
            {optionsData?.map((option) => (
              <MenuItem
                key={option}
                value={option}
                sx={{
                  fontSize: '12px',
                }}
                style={getStyles(option, optionValues, theme)}
              >
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
}
